export const SHOP_EVENT_LOCATION = "shop";

export const ANALYTICS_SHOP_TYPE = {
  SHOP: "shop",
  BUNDLE: "bundle-shop",
  PRICELESS: "priceless-shop",
  LOCKER: "locker-shop",
} as const;

export const ANALYTICS_TARGET_ADD_TO_BAG = "add_to_bag";
export const ANALYTICS_TARGET_ADDED_TO_BAG = "added_to_bag";
export const ANALYTICS_TARGET_ATTRIBUTE = "attribute";
export const ANALYTICS_TARGET_QUANTITY = "quantity";
export const ANALYTICS_TARGET_DESCRIPTION_INFO = "description_info";
export const ANALYTICS_TARGET_REDEMPTION_INFO = "redemption_info";
export const ANALYTICS_TARGET_DIETARY_INFO = "dietary_info";
export const ANALYTICS_TARGET_IMAGE = "image";

export const SHOP_NAV_ANALYTICS_TARGET = {
  CATEGORY: "category",
  SUBCATEGORY: "subcategory",
};

export const ANALYTICS_ATTRIBUTE_TYPE = {
  COLOR: "color",
  SIZE: "size",
  AMOUNT: "amount",
  BOX_SIZE: "box_size",
};
